import React from 'react';
import {StyleSheet, TouchableOpacity, View} from 'react-native';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import {faChevronLeft, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import Colors from '../constants/Colors';
import {Text} from './Themed';

interface Props {
  position: number;
  total: number;
  onPrevious: () => void;
  onNext: () => void;
}

export default function ResponseHistoryNavigation({position, total, onPrevious, onNext}: Props) {
  const previousDisabled = position <= 1;
  const nextDisabled = position >= total;
  return <View style={styles.navigation}>
    <TouchableOpacity
      accessibilityRole="button"
      accessibilityLabel="Previous question and response"
      accessibilityState={{disabled: previousDisabled}}
      disabled={previousDisabled}
      onPress={previousDisabled ? undefined : onPrevious}
      style={[styles.button, previousDisabled && styles.disabled]}>
      <FontAwesomeIcon icon={faChevronLeft} color={Colors.dark.text} size={18}/>
    </TouchableOpacity>
    <TouchableOpacity
      accessibilityRole="button"
      accessibilityLabel="Next question and response"
      accessibilityState={{disabled: nextDisabled}}
      disabled={nextDisabled}
      onPress={nextDisabled ? undefined : onNext}
      style={[styles.button, nextDisabled && styles.disabled]}>
      <FontAwesomeIcon icon={faChevronRight} color={Colors.dark.text} size={18}/>
    </TouchableOpacity>
    <Text accessibilityLiveRegion="polite" style={styles.position}>{position} / {total}</Text>
  </View>;
}

const styles = StyleSheet.create({
  navigation: {flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'},
  button: {width: 44, height: 44, alignItems: 'center', justifyContent: 'center', borderRadius: 6},
  disabled: {opacity: 0.35},
  position: {fontSize: 14, marginHorizontal: 8},
});
